export default "__VITE_ASSET__DOjTyLI$__"